<template>
  <div>
    <van-form @submit="onSubmit">
      <!-- <van-field
        v-model="username"
        name="用户名"
        label="奖品名称"
        placeholder="奖品名称"
        :rules="[{ required: true, message: '请填写奖品名称' }]"
      />
      <van-field
        v-model="number"
        type="number"
        name="奖品份数"
        label="奖品份数"
        placeholder="奖品份数"
        :rules="[{ required: true, message: '请填写奖品份数' }]"
      /> -->
      <div class="add-list" v-for="(item, index) in addList" :key="index">
        <div > 
          <van-image`
          v-if="isShowImg"
          class="opt-img"
          :src="require('@/assets/img/delete.png')"
          @click="onDelete(index)"
        />
         <van-field
         name="id"
          v-model="item.id"
          v-if="item.id != ''"
          v-show="false"
        />
        <van-field
         name="name"
          v-model="item.name"
          label="奖品名称"
          placeholder="奖品名称"
          :rules="[{ required: true, message: '请填写奖品名称' }]"
        />
        <van-field
         name="acount"
          v-model="item.acount"
          type="number"
          label="奖品份数"
          placeholder="奖品份数"
          :rules="[{ required: true, message: '请填写奖品份数' }]"
        />
        </div>
      </div>
      <van-button icon="plus" plain type="info" @click.prevent="addDataList">添加新奖项</van-button>
      
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { Dialog } from 'vant'
import URL from "@/api/api"; 
export default {
  data() {
    return {
     isShowImg:false,
      addList: [
        {label: "奖品名称", name: "", label2: "奖品份数", acount: "" },
      ],
      id:"",
      type:""
    };
  },
  created(){this.fetchdata()},
 watch:{
  addList:{
    handler(){
      if(this.addList.length>=2){
        this.isShowImg=true
      }else{
        this.isShowImg=false
      }
    }
  }
 },
  methods: {
   fetchdata(){
     this.id=this.$route.query.id;
     this.type=this.$route.query.type;
     if(this.type=="0"){
          this.$fetchGet(URL.getawardlist.url+this.id).then(res=>{
       this.addList=res.data.data.batches;
     })
     } 
     
   },
    onSubmit(values) {
      var dataList=[]
      var updateList=[]
      var id=this.$route.query.id
      
     
      if(this.type=="1"){
        this.addList.map(x=>{
            var dataName={}
            dataName.name=x.name
            dataName.acount=x.acount
            dataName.batchId=id
            dataName.balance=x.acount
            dataList.push(dataName) 
      })
      this.$fetchPost(URL.saveBatch.url,dataList).then(()=>{
        this.$router.push({path:'/createLottery/details'});
      })
      }else{
        this.addList.map(x=>{
        var dataName={}
        dataName.name=x.name
        dataName.acount=x.acount
        dataName.id=x.id
        dataName.batchId=id
        dataName.balance=x.acount
        updateList.push(dataName)
      })
        this.$fetchPost(URL.updateawardlist.url,updateList)
      }

    },
    //添加新奖项
    addDataList(){
      this.addList.push({label: "奖品名称", name: "", label2: "奖品份数", number: "" })
    },
    //删除
    onDelete(index) {
     this.addList.map((x, i) => {
            if (i == index) {
              if(this.type=="0"){
                this.$fetchGet(URL.deleteaward.url,{id:x.id})
              }  
              this.addList.splice(i, 1);
            }
          });
    },
  },
};
</script>
<style scoped>
.add-list {
  position: relative;
}
.opt-img {
  position: absolute;
  z-index: 9;
  width: 20px;
  top: 10px;
}
.add-list >>> .van-field__label {
  padding-left: 10px;
}
.van-button--normal{
  margin: 15px 0;
}
</style>